<div class="unit is-flex gap-4 is-space-between text-grey-70 radius-8 is-cursor-pointer"
  [class.bg-blue-10]="selected()"
  [class.text-blue]="selected()"
  [class.bg-blue-hover-5]="selected()"
  [class.bg-grey-hover-10]="!selected()"
  (click)="select.emit()">
  <app-text class="text-14 is-family-semiBold ellipsis"
    [text]="label()" />
    @if (selected()) {
      <app-icon name="check" class="text-blue text-20" />
    }
</div>